/* my-Harry · Widerrufsformular (§ 356a BGB)
   Wichtig: Das Formular wird NICHT programmatisch abgeschickt. Shopify hängt sich bei aktiviertem
   Spam-Schutz in das submit-Event, um hCaptcha zu prüfen – ein form.submit() würde das umgehen.
   Dieses Skript füllt beim Absenden nur versteckte Felder und lässt den nativen Versand laufen. */
(function () {
  var KEY = 'mhWiderruf';

  function init(root) {
    if (!root || root.dataset.mhwReady) return;
    root.dataset.mhwReady = '1';

    var klaviyo = (root.dataset.klaviyo || '').trim();

    /* Erfolgsseite: gespeicherte Zusammenfassung anzeigen */
    if (root.querySelector('[data-mhw-success]')) {
      try {
        var d = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (d) {
          var box = root.querySelector('[data-mhw-summary]');
          ['zeit', 'name', 'email', 'bestellung', 'umfang'].forEach(function (k) {
            var el = box.querySelector('[data-k="' + k + '"]');
            if (el) el.textContent = d[k] || '–';
          });
          box.hidden = false;
        }
      } catch (e) {}
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;

    var items = root.querySelector('[data-mhw-items]');
    var itemsInput = items ? items.querySelector('textarea') : null;

    function syncScope() {
      var checked = form.querySelector('[data-mhw-scope]:checked');
      if (!checked || !items) return;
      var partial = checked.value === 'Nur einzelne Artikel';
      items.hidden = !partial;
      if (itemsInput) itemsInput.required = partial;
    }
    root.querySelectorAll('[data-mhw-scope]').forEach(function (r) {
      r.addEventListener('change', syncScope);
    });
    syncScope();

    var sending = false;
    form.addEventListener('submit', function () {
      if (sending) return;
      sending = true;

      var now = new Date();
      var zeit;
      try {
        zeit = now.toLocaleString('de-DE', {
          timeZone: 'Europe/Vienna', dateStyle: 'long', timeStyle: 'medium'
        });
      } catch (e) {
        zeit = now.toString();
      }

      function val(n) {
        var el = form.querySelector('[name="contact[' + n + ']"]');
        return el ? el.value.trim() : '';
      }
      var scope = form.querySelector('[data-mhw-scope]:checked');
      var umfang = scope ? scope.value : '';
      var data = {
        zeit: zeit,
        iso: now.toISOString(),
        name: val('name'),
        email: val('email'),
        bestellung: val('Bestellnummer'),
        umfang: umfang === 'Nur einzelne Artikel' ? umfang + ': ' + val('Artikel') : umfang
      };

      var timeField = form.querySelector('[data-mhw-time]');
      if (timeField) timeField.value = zeit + ' / ' + data.iso;

      var bodyField = form.querySelector('[data-mhw-body]');
      if (bodyField) {
        bodyField.value =
          'WIDERRUF\n\nHiermit widerrufe ich den von mir abgeschlossenen Vertrag.\n\n' +
          'Name: ' + data.name + '\nE-Mail: ' + data.email +
          '\nBestellnummer: ' + data.bestellung +
          '\nUmfang: ' + data.umfang +
          '\nZeitpunkt: ' + zeit + ' (' + data.iso + ')';
      }

      try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}

      /* Optional: Klaviyo-Event für die automatische Eingangsbestätigung (fire and forget). */
      if (klaviyo) {
        try {
          fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyo), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: {
                    Bestellnummer: data.bestellung,
                    Name: data.name,
                    Umfang: data.umfang,
                    Zeitpunkt: zeit,
                    ZeitpunktISO: data.iso
                  },
                  time: data.iso,
                  unique_id: 'widerruf-' + data.bestellung + '-' + now.getTime(),
                  metric: { data: { type: 'metric', attributes: { name: 'Widerruf eingereicht' } } },
                  profile: { data: { type: 'profile', attributes: { email: data.email } } }
                }
              }
            }),
            keepalive: true
          }).catch(function () {});
        } catch (e) {}
      }

      /* Button erst nach dem Start des Versands sperren, damit die Formulardaten mitgehen.
         Nach 10 s wieder freigeben – falls die Captcha-Prüfung abgebrochen wurde. */
      var btn = form.querySelector('[data-mhw-submit]');
      if (btn) {
        var label = btn.textContent;
        setTimeout(function () {
          btn.disabled = true;
          btn.textContent = 'Wird übermittelt …';
        }, 0);
        setTimeout(function () {
          sending = false;
          btn.disabled = false;
          btn.textContent = label;
        }, 10000);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-mhw-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
